import { defineComponent as s, ref as f, computed as u } from "vue";
import { H as d } from "./dom-B5R6OWVp.js";
var p = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(p || {});
let h = s({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: o, attrs: t }) {
  return () => {
    let { features: i, ...r } = e, n = { "aria-hidden": (i & 2) === 2 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(i & 4) === 4 && (i & 2) !== 2 && { display: "none" } } };
    return d({ ourProps: n, theirProps: r, slot: {}, attrs: t, slots: o, name: "Hidden" });
  };
} });
function m(e = {}, o = null, t = []) {
  for (let [i, r] of Object.entries(e)) a(t, l(o, i), r);
  return t;
}
function l(e, o) {
  return e ? e + "[" + o + "]" : o;
}
function a(e, o, t) {
  if (Array.isArray(t)) for (let [i, r] of t.entries()) a(e, l(o, i.toString()), r);
  else t instanceof Date ? e.push([o, t.toISOString()]) : typeof t == "boolean" ? e.push([o, t ? "1" : "0"]) : typeof t == "string" ? e.push([o, t]) : typeof t == "number" ? e.push([o, `${t}`]) : t == null ? e.push([o, ""]) : m(t, o, e);
}
function y(e) {
  var o;
  let t = (o = e == null ? void 0 : e.form) != null ? o : e.closest("form");
  if (t) {
    for (let i of t.elements) if (i.tagName === "INPUT" && i.type === "submit" || i.tagName === "BUTTON" && i.type === "submit" || i.nodeName === "INPUT" && i.type === "image") {
      i.click();
      return;
    }
  }
}
function b(e, o, t) {
  let i = f(t == null ? void 0 : t.value), r = u(() => e.value !== void 0);
  return [u(() => r.value ? e.value : i.value), function(n) {
    return r.value || (i.value = n), o == null ? void 0 : o(n);
  }];
}
export {
  p as a,
  b as d,
  m as e,
  h as f,
  y as p
};
//# sourceMappingURL=use-controllable-BEb0o1U6.js.map
